var Prize = new Vue({
	el: '.prizes',
	data() {
		return {
			images: ['https://cdn.shopify.com/s/files/1/0812/5130/3768/files/overlay-1a.png'],
			wheel: null,
			message: '',
			playing: false,
			coupon: '',
			prize: {},
			subscribed: false,
			ajax: false,
			alertMessage: ''
		};
	},
	mounted() {
		$( '.prizes .buttons.hidden' ).removeClass( 'hidden' );
		if ( ! localStorage.getItem( 'played' ) || localStorage.getItem( 'played' ) == 'false' ) {
			$( '.prizes' ).addClass( 'active' );
		}
		this.prizes.forEach(prize => {
			if ( prize.image ) {
				this.images.push( prize.image );
			}
		});
		this.preloadImages(this.images).then(images => {
			this.initializeWheel(images);
		}).catch(error => {
			console.error( 'Failed to preload images.', error );
		});
		this.message = this.theme.data[ 'prizes-description' ];
	},
	computed: {
		prizes() {
			let data = Prizes ? Prizes : [];
			return data.concat( data );
		},
		theme() {
			return prizeTheme ? prizeTheme : {};
		}
	},
	methods: {
		preloadImages(imageSources) {
			return Promise.all(imageSources.map(src => {
				return new Promise((resolve, reject) => {
					const img = new Image();
					img.src = src;
					img.onload = () => resolve(img);
					img.onerror = reject;
				});
			}));
		},
		initializeWheel(images) {
			const _this = this;
			const props = {
				borderColor: '#F9F3F5',
				borderWidth: 0,
				overlayImage: images[0],
				items: this.prizes.map((item, i) => ({
					// image: image,
					// imageRadius: 0.5,
					// imageScale: 0.225,
                    label: item.data.text,
				})),
				itemBackgroundColors: _this.theme.data[ 'prizes-colours' ],
                itemLabelColors: ['#FFFFFF'],
                itemLabelFont: 'Body, sans-serif',
                itemLabelFontSizeMax: 17,
                itemLabelRadius: 0.875,
				lineColor: _this.theme.data[ 'prizes-lines' ],
				lineWidth: 1,
				radius: 0.9375,
				pointerAngle: 90,
				isInteractive: false,
			};

			const container = this.$refs.prize;
			this.wheel = new spinWheel.Wheel(container, props);
			let index  = Math.floor( Math.random() * this.wheel.items.length );
			this.wheel.spinToItem(index);
			this.wheel.onRest = (event) => {
				_this.getSpinResult();
			};
		},
		async play() {	
			if ( this.subscribed ) {
				return;
			}
			const _this = this;
			this.alertMessage = '';
			let randomChance = Math.random() * 100;
			let cumulativeChance = 0;
			let index = -1;
			this.prize = {};
			for ( let i = 0; i < this.prizes.length - 1; i++ ) {
				const odds = parseFloat( _this.prizes[i].data.odds );
				cumulativeChance += odds;
				if (randomChance <= cumulativeChance) {
					index = i;
					break;
				}
			}	
			this.prize = this.prizes[index];
			this.ajax = true;
			const response = await this.subscribe();
			this.ajax = false;
			this.coupon = response.coupon;
			if ( response.success ) {
				this.subscribed = true;
				if ( ! this.coupon ) {
					index = this.prizes.findIndex( prize => prize.data.text == 'No Win' );
					this.prize = this.prizes[index];
				}
				this.wheel.spinToItem( index, 4000, true, 2, 1, null );
				this.playing = true;
			} else if ( response.message ) {
				if ( response.message.includes( 'A profile already exists' ) ) {
					response.message = `Oops! It looks like you have already subscribed to 2bTanned.`;
				} else {
					response.message = `${response.message}.`;
				}
				this.alertMessage = response.message;
			}
			if ( ! response.message.includes( 'Invalid email address' ) ) {
				localStorage.setItem( 'played', true );
			}
		},
		getSpinResult() {
			if ( ! this.playing ) {
				return;
			}
			if ( this.prize.data.text == 'No Win' ) {
				this.message = `Unfortunately, you haven't won anything this time. Thank you for subscribing to 2bTanned.`;
			} else {
				if ( this.prize.data.description ) {
					this.message = this.prize.data.description;
				} else {
					this.message = `Congratulations! You have won the ${this.prize.data.text}! Simply copy the coupon below and use it at the checkout. Thank you for subscribing to 2bTanned.`;
				}
			}
			this.playing = false;
		},
		copyToClipboard(e) {
			var copyText = document.getElementById( 'coupon' );
			copyText.select();
			copyText.setSelectionRange( 0, 99999 );
			navigator.clipboard.writeText( copyText.value );
			const $button = $(e.target);
			$button.parent().find( '.text' ).text( 'Copied' );
		},
		async subscribe() {
			const prize = encodeURIComponent( this.prize.data.coupon );
			const email = $( '.prizes .form.subscription input[name="email"]' ).val();
			const url = `https://alt.2btanned.com/api/index.php/subscribe?email=${email}&prize=${prize}`;
			const payload = {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json'
				},
				redirect: 'follow'
			};
			try {
				const response = await fetch(url, payload);
				const data = await response.json();
				return data;
			} catch (error) {
				console.error('Error:', error);
				return { success: false, message: 'An error occurred. Please try again later.' };
			}
		},
		close() {
			$( '.prizes' ).removeClass( 'active' );
			localStorage.setItem( 'played', true );
		}
	}
});